import { AdaLocalizedDatePipe } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { CpeWebViewTableComponentModule } from '@adaptiva/metadata/widgets';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ViewCveInfoActionOverlayComponent } from './view-cve-info-action-overlay.component';

const _pipes = [
	AdaLocalizedDatePipe
];

const _widgets = [
	CardComponentModule,
	ContainerComponentModule,
	CpeWebViewTableComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		_pipes,
		_widgets,
		CommonModule,
		DynamicComponentLoaderModule.forChild(ViewCveInfoActionOverlayComponent),
	],
	declarations: [ViewCveInfoActionOverlayComponent],
	exports: [ViewCveInfoActionOverlayComponent]
})
export class ViewCveInfoActionOverlayComponentModule {

}
